import React from "react";
import _ from "lodash";

const STATUS = {
  RUNNING: "RUNNING",
  PAUSED: "PAUSED",
};

class StatusLabel extends React.Component {
  render() {
    const { status, count = 0 } = this.props;
    return count > 0 ? (
      <div
        className={`rounded-full px-2 py-1 text-xs ${
          status === STATUS.RUNNING
            ? "border border-green-400 bg-green-100 text-green-700"
            : "border border-gray-500 bg-gray-100 text-gray-700"
        }`}
      >
        {_.startCase(status)} (<span className="font-semibold">{count}</span>)
      </div>
    ) : (
      ""
    );
  }
}

export default StatusLabel;
